module.exports = __webpack_public_path__ + "img/star.8ce2ccc4.svg";